var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    stroke: "black",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9784 4.23619V4.23619C16.4518 6.72119 16.4518 10.7378 13.9784 13.2228V13.2228L11.3565 15.8534C10.3361 16.8787 8.67764 16.8826 7.65233 15.8622L7.64362 15.8534L5.02172 13.2228C2.54844 10.7378 2.54842 6.72123 5.02168 4.23619V4.23619C7.48335 1.76287 11.484 1.75342 13.9573 4.21509L13.9784 4.23619H13.9784Z",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.875 8.41447V10.2917C11.875 10.7289 11.5206 11.0834 11.0833 11.0834H7.91667C7.47944 11.0834 7.125 10.7289 7.125 10.2917V8.36885C7.125 8.12835 7.23433 7.90089 7.42213 7.75065L8.97696 6.50684C9.26609 6.27555 9.67691 6.27555 9.96604 6.50684L11.5779 7.79627C11.7657 7.94651 11.875 8.17397 11.875 8.41447Z",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.1fde7e15f31f595e93b2f86678b67fb0.svg";
export { ForwardRef as ReactComponent };